import Carousel from "react-material-ui-carousel";
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { API } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/auth/lib";
import { retrieveVOClients } from "./graphql/queries";

interface CarouselItem {
  rows: CompanyName[]
}

interface CompanyName {
  zhName: string;
  enName: string;
}

function CompanyCarousel() {
  const [items, setItems] = useState<CompanyName[][]>([])

  useEffect(() => {
    downloadCompanyList().then((response: GraphQLResult<any>) => {
      const chunkSize = 45;
      const items = [];
      for (let i = 0; i < response.data.retrieveVOClients.length; i += chunkSize) {
        const chunk = response.data.retrieveVOClients.slice(i, i + chunkSize);
        items.push(chunk);
        // do whatever
      }
      setItems(items)
    });

  }, []);

  const downloadCompanyList = async () => {
    const response: GraphQLResult<any> = await API.graphql({
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
      query: retrieveVOClients,
    })
    return response
  }

  return (
    <Carousel interval={20000} stopAutoPlayOnHover={false} duration={0}>
      {
        items.map((item, i) => <Item key={i} rows={item} />)
      }
    </Carousel>
  )
}

function Item(props: CarouselItem) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
          {props.rows.map((row) => (
            <TableRow
              key={row.enName}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.enName}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.zhName}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default CompanyCarousel;
